<script setup lang="ts">
import { LANDING_CONTENT } from '~/utils/constants'
const stats = LANDING_CONTENT.STATS
</script>

<template>
  <section class="py-16 bg-white dark:bg-gray-950 border-y border-gray-100 dark:border-gray-800">
    <UContainer>
      <div class="grid grid-cols-2 lg:grid-cols-4 gap-8">
        <div
          v-for="stat in stats"
          :key="stat.label"
          class="flex flex-col items-center text-center space-y-2 group"
        >
          <div
            class="w-12 h-12 rounded-2xl bg-primary-50 dark:bg-primary-900/20 flex items-center justify-center text-primary-500 mb-2 group-hover:scale-110 transition-transform"
          >
            <UIcon :name="stat.icon" class="w-6 h-6" />
          </div>
          <h3 class="text-3xl font-bold tracking-tight text-gray-900 dark:text-white">
            {{ stat.value }}
          </h3>
          <p class="text-sm font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
            {{ stat.label }}
          </p>
        </div>
      </div>
    </UContainer>
  </section>
</template>
